import { Http } from 'lib'

import { enterprisePlaylistInitialState, EnterprisePlaylistState, IPlaylistData } from './store/State'

import enterprisePlaylistReducer from './store/Reducer'

import { reset, setPlaylistData, toggleIsLoading, setInfoLoadedState, EnterprisePlaylistAction } from './store/Actions'

import ServiceProviderBase from 'lib/ServiceProviderBase'
import apiUrlsAddresses from 'config/constants/api-urls-addresses'

export class EnterprisePlaylistService extends ServiceProviderBase<EnterprisePlaylistState, EnterprisePlaylistAction> {
  constructor() {
    super(enterprisePlaylistInitialState)
  }

  reduce(state: EnterprisePlaylistState, action: EnterprisePlaylistAction): EnterprisePlaylistState {
    return enterprisePlaylistReducer(state, action)
  }

  reset() {
    this.dispatch(reset())
  }

  async loadPlaylistData(enterpriseId: string, playlistCode: string): Promise<string> {
    this.dispatch(toggleIsLoading())

    const [response, code, error] = await Http.get(
      apiUrlsAddresses.enterprisePlaylist.fetch(enterpriseId, playlistCode),
      { unauthorizedErrorExpected: true }
    )

    this.dispatch(toggleIsLoading())

    if (code === 200) {
      this.dispatch(setPlaylistData(response as IPlaylistData, 'LOADED'))
    }

    if (code === 404) {
      this.dispatch(setInfoLoadedState('NOT_FOUND'))
    }

    if (code === 401) {
      this.dispatch(setInfoLoadedState('UNAUTHORIZED'))
    }

    return error
  }
}

let instance: EnterprisePlaylistService = null

export default (() => {
  if (!instance) {
    instance = new EnterprisePlaylistService()
  }

  return instance
})()
